// extracted by mini-css-extract-plugin
export default {"video-feed":"VideoUser_video-feed__5P9pc","video":"VideoUser_video__qAwNI","video-big":"VideoUser_video-big__y85Mf"};